import React from "react";
import styled from "styled-components";
import { Spacing } from "@glossy";
import Icon from "@ui-kit/icon";
import { Label } from "@radarly/components/clause/labels/label/index";
import { QueryClauseLabel } from "@radarly/models/clause/label";

const StyledIcon = styled(Icon)`
  margin-right: ${Spacing.Small};
`;

export const queryLabel = (
  label: QueryClauseLabel,
  excluded: boolean = false
) => (
  <>
    <StyledIcon glyph="magnifier" />
    <Label excluded={excluded}>{label.label}</Label>
  </>
);
